let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1WVCN")).then(() => parcelRequire('jkipX'));